"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const ProgressBar = ({ length, active }) => ((0, jsx_runtime_1.jsx)("div", { className: styles_module_css_1.default.progressBar, children: Array(length)
        .fill('')
        .map((_, index) => ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(styles_module_css_1.default.progressBarItem, {
            [styles_module_css_1.default.progressBarItemActive]: index + 1 <= active,
        }) }, index + 1))) }));
exports.default = ProgressBar;
